import { setFrontendLocale } from '@/composables/useFrontendLocale'
import type { PageProps } from '@/types'
import { router } from '@inertiajs/vue3'

const setLocaleFromPageProps = (pageProps?: Partial<PageProps>) => {
  setFrontendLocale(pageProps?.app?.locale)
}

export function useInertiaLocaleSync(initialPageProps?: Partial<PageProps>) {
  setLocaleFromPageProps(initialPageProps)

  router.on('success', (event) => {
    setLocaleFromPageProps(event.detail.page.props)
  })
}
